// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionPubli.js
import React from "react";
import { Segment, Header } from "semantic-ui-react";
import "./InstitutionPubli.scss";

export function InstitutionPubli({ url }) {
  return (
    <Segment padded>
      <Header as="h3">Sitio / Publicidad</Header>
      <div className="iframe-container">
        <iframe
          src={url || "about:blank"}
          title="Institución"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </Segment>
  );
}
